import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  user: null,
  isAuthenticated: false,
  isInitialized: false,
};

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
setUser: (state, action) => {
      // Deep sanitize user object to prevent proxy errors and ensure complete serializability
      if (action.payload) {
        try {
          // Create a completely clean, serializable user object
          const sanitizedUser = {
            id: action.payload.id ? String(action.payload.id) : null,
            email: action.payload.email ? String(action.payload.email) : null,
            name: action.payload.name ? String(action.payload.name) : null,
            companyId: action.payload.companyId ? String(action.payload.companyId) : null,
          };

          // Handle metadata with deep sanitization and error protection
          if (action.payload.metadata && typeof action.payload.metadata === 'object') {
            try {
              // Ensure deep cloning and remove any non-serializable references
              const metadataString = JSON.stringify(action.payload.metadata, (key, value) => {
                // Filter out functions, undefined, and other non-serializable values
                if (typeof value === 'function' || value === undefined) {
                  return null;
                }
                return value;
              });
              sanitizedUser.metadata = JSON.parse(metadataString);
            } catch (metadataError) {
              console.warn('USER_SLICE: Failed to serialize user metadata:', metadataError);
              sanitizedUser.metadata = {};
            }
          }

          state.user = sanitizedUser;
          state.isAuthenticated = true;
        } catch (sanitizationError) {
          console.error('USER_SLICE: Failed to sanitize user data:', sanitizationError);
          state.user = null;
          state.isAuthenticated = false;
        }
      } else {
        state.user = null;
        state.isAuthenticated = false;
      }
    },
    clearUser: (state) => {
      state.user = null;
      state.isAuthenticated = false;
    },
    setInitialized: (state, action) => {
      state.isInitialized = action.payload;
    },
  },
});

export const { setUser, clearUser, setInitialized } = userSlice.actions;
export default userSlice.reducer;